module.exports = __webpack_public_path__ + "static/img/finish_img.546f348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/finish_img.png
// module id = IcGb
// module chunks = 1